import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/workspace/source/artist-center.idus.com/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/workspace/source/artist-center.idus.com/layouts/home.vue").then(m => m.default || m))
}